import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';

import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export default function Team() {
  const people = [
    {
      image: '//s3.amazonaws.com/boatbound_development/comfy/cms/files/files/000/000/035/original/graham-goldsmith.jpg',
      name: 'Graham Goldsmith',
      position: t`contact.team.directorOfSales`,
    },
    {
      image: `${publicRuntimeConfig.ASSETS_PREFIX}/images/team/blake.png`,
      name: 'Blake Edwards',
      position: t`contact.team.charterSpecialist`,
    },
    {
      image: `${publicRuntimeConfig.ASSETS_PREFIX}/images/team/dima.png`,
      name: 'Dima Warner',
      position: t`contact.team.charterSpecialist`,
    },
  ];
  return (
    <TeamSection>
      <HR />
      <ContentWrapper>
        <TeamsHeading>
          <Trans id="contact.team.heading" />
        </TeamsHeading>
        <TeamsSmallerHeading>
          <Trans id="contact.team.smallerHeading" />
        </TeamsSmallerHeading>

        <TeamsDescription>
          <Trans id="contact.team.description" />
        </TeamsDescription>

        <TeamsSmallerHeading>
          <Trans id="contact.team.bsTeam" />
        </TeamsSmallerHeading>

        <Row>
          <TeamsDescriptionFlex>
            <Trans id="contact.team.bsTeamDescription" />
          </TeamsDescriptionFlex>

          <PeopleWrapper>
            <People>
              {people.map((person, i) => (
                <PersonWrapper key={i}>
                  <Image src={person.image} />
                  <Data>
                    <Name>{person.name}</Name>
                    <Position>
                      <Trans id={person.position} />
                    </Position>
                  </Data>
                </PersonWrapper>
              ))}
            </People>
          </PeopleWrapper>
        </Row>
      </ContentWrapper>
    </TeamSection>
  );
}

const TeamSection = styled.div`
  background-color: #17233c;
  color: white;
`;

const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 1140px;
  padding: 2.2em;
`;

const TeamsHeading = styled.div`
  font-size: 30px;
  line-height: 48px;
  font-weight: 500;
  color: #fff;
  margin: 0 0 20px 0;
`;

const TeamsSmallerHeading = styled.h4`
  font-size: 1.25em;
  line-height: 1.4;
  margin-bottom: 0.4em;
`;

const TeamsDescription = styled.div`
  color: #dbdfe5;
  margin-bottom: 2em;
  padding-right: 2em;
`;

const TeamsDescriptionFlex = styled(TeamsDescription)`
  flex: 0 0 50%;
`;

const Row = styled.div`
  display: flex;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const People = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
`;

const Image = styled.img`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  margin-right: 20px;
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Name = styled.div`
  font-size: 1em;
  font-weight: 500;
`;

const Position = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.75em;
`;

const PersonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2em;
  margin-right: 1em;
  width: 45%;

  @media (max-width: 750px) {
    width: 100%;
  }
`;

const PeopleWrapper = styled.div`
  flex-basis: auto !important;
`;

const HR = styled.hr`
  border-color: rgba(255, 255, 255, 0.18);
  max-width: calc(1140px - 4.2rem);
  margin: 0 auto;
`;
